import config from "../config/config";
import { userService } from "../services";

export const DetailsAction = {
  fetchDistanceDetails,
  getDistanceThroughCoordinates,
  fetchLostDistanceDetails
};

async function fetchDistanceDetails(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.distance;
    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchLostDistanceDetails(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.getGpsLost;
    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function getDistanceThroughCoordinates(payload) {
  try {
    const apiEndpoint =
      config.baseUrl + config.apiName.getDistanceThroughCoordinates;
    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}
